import { load } from "ts-dotenv";

export const environment = load({
  REACT_APP_APP_REGISTRATION_URL: String,
  REACT_APP_API_URL: String,
  REACT_APP_LANGUAGE: ["nl" as const, "en" as const],
});
